import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import NOBC from '../views/NOBC.vue'
import Container from '../components/NOBC/Container.vue'
import ContainerONP from '../components/ONP/Container.vue'
import Main from '../components/Main.vue'
import Warning from '../components/Warning.vue'
import WarningMobile from '../components/WarningMobile.vue'
import WarningONP from '../components/WarningONP.vue'
import WarningMobileONP from '../components/WarningMobileONP.vue'
import VueMeta from 'vue-meta'

Vue.use(VueRouter)
Vue.use(VueMeta)
const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Main
  },
  {
    path: '/warning',
    name: 'Warning',
    component: Warning
  }, {
    path: '/warningMobile',
    name: 'WarningMobile',
    component: WarningMobile
  },
  {
    path: '/warningONP',
    name: 'WarningONP',
    component: WarningONP
  }, {
    path: '/warningMobileONP',
    name: 'WarningMobileONP',
    component: WarningMobileONP
  },
  {
    path: '/holdyourfart',
    name: 'holdyourfart',
    component: Container
  },
  
  { path: '/holdyourpart', redirect: '/holdyourfart' },
  { path: '/onp', redirect: '/oldmanseaplastics' },
  { path: '/oldmanseaplastics-desktop', redirect: '/oldmanseaplastics' },
  {
    path: '/oldmanseaplastics',
    name: 'ONP',
    component: ContainerONP
  },
  {
    // path: "*",
    path: "/:catchAll(.*)"
    , redirect: '/' },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


export default router
